import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from "@mui/material";
import { Button } from "pepsico-ds";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { STATUS } from "./storeConstants";

const RenameStoreGroupModal = ({
  isOpen,
  targetGroup,
  targetStatus,
  onClose,
  onConfirm,
  loading = false,
  isSyncMarket = false,
}) => {
  const [newGroupName, setNewGroupName] = useState("");
  const [status, setStatus] = useState(STATUS.ACTIVE);
  const initialStatus = targetStatus || STATUS.ACTIVE;

  useEffect(() => {
    if (isOpen) {
      setNewGroupName(targetGroup || "");
      setStatus(initialStatus);
    }
  }, [isOpen, targetGroup, initialStatus]);

  const trimmedName = newGroupName.trim();
  const nameChanged = trimmedName !== targetGroup;
  const statusChanged = status !== initialStatus;

  const handleConfirm = () => {
    if (!trimmedName || (!nameChanged && !statusChanged)) {
      return;
    }
    onConfirm(trimmedName, status);
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <h3 style={{ margin: 0 }}>
              {isSyncMarket ? "Update Store Group" : "Rename Store Group"}
            </h3>
          </Grid>
          <Grid item>
            <CloseIcon onClick={onClose} className="cursor-pointer" />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus={!isSyncMarket}
          fullWidth
          size="small"
          label="Group Name"
          value={newGroupName}
          onChange={(e) => setNewGroupName(e.target.value)}
          disabled={isSyncMarket}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <Button variant="secondary" onClick={onClose} text="Cancel" size="small" />
        <div className="display-flex align-items-center">
          <FormControlLabel
            control={
              <Switch
                checked={status !== STATUS.INACTIVE}
                onChange={(e) =>
                  setStatus(e.target.checked ? STATUS.ACTIVE : STATUS.INACTIVE)
                }
                disabled={loading}
              />
            }
            label={status === STATUS.INACTIVE ? "Inactive" : "Active"}
          />
          <Button
            variant="primary"
            onClick={handleConfirm}
            text="Save"
            size="small"
            disabled={loading || !trimmedName || (!nameChanged && !statusChanged)}
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

RenameStoreGroupModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  targetGroup: PropTypes.string,
  targetStatus: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  isSyncMarket: PropTypes.bool,
};

export default RenameStoreGroupModal;
